export const colorToSemanticVariant = (variant: string) => {
  switch (variant) {
    case 'orange':
      return 'primary';
    case 'orange-outline':
      return 'primary-outline';
    case 'orange-circle':
      return 'primary-circle';
    case 'blue':
      return 'info';
    case 'blue-outline':
      return 'info-outline';
    case 'blue-circle':
      return 'info-circle';
    case 'red':
      return 'error';
    case 'red-outline':
      return 'error-outline';
    case 'red-circle':
      return 'error-circle';
    case 'yellow':
      return 'warning';
    case 'yellow-outline':
      return 'warning-outline';
    case 'yellow-circle':
      return 'warning-circle';
    case 'green':
      return 'success';
    case 'green-outline':
      return 'success-outline';
    case 'green-circle':
      return 'success-circle';
    case 'gray':
    case 'plain':
      return 'dim';
    case 'gray-outline':
      return 'dim-outline';
    case 'gray-circle':
      return 'dim-circle';

    default:
      return variant;
  }
};
